export const CSS_DIP = 96 / 72;

/** 计算当前设备的DPI */
export const getDeviceDIP = () => {
    const node = document.createElement("div");
    let x = 96, y = 96;
    node.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
    document.body.appendChild(node);
    x = parseInt(node.offsetWidth);
    y = parseInt(node.offsetHeight);
    node.parentNode.removeChild(node);
    return { x, y }
}


let uid = 100000;
const uidWkMap = new WeakMap();
export const get_uid = function (obj) {
    !uidWkMap.has(obj) &&
        uidWkMap.set(obj, (uid++).toString(16));
    return uidWkMap.get(obj)
}

export const IN_TO_MM = 25.4;  // 1in = 25.4mm 英寸毫米


/** 获取页面位置 尺寸等信息 */
export function getPagePositionConfigs (pages = [], scale = 1) {
    const config = [];
    let currentHeight = 0;
    const MARGIN_BOTTOM = 24;

    pages.forEach(page => {
        const { height } = page.getViewport({ scale });
        const { pageNumber } = page;

        config.push({
            top: currentHeight,
            height,
            pageNumber
        })

        currentHeight += height + MARGIN_BOTTOM;
    });

    return {
        totalHeight: currentHeight - 24,
        positions: config
    }
}